import { Container } from "@material-ui/core";
import useLanguageStore from "@stores/languageStore";
import { useTranslation } from "react-i18next";
import SEOHead from "../../components/SEOHead";
import SectionHeader from "../../components/SectionHeader";

const PrivacyPage = () => {
	const { t } = useTranslation();
	const { language } = useLanguageStore();
	const isRtl = language === "he";

	return (
		<div
			className={`min-h-[calc(100vh-64px)] py-20 sm:py-32 max-w-[100vw] overflow-x-hidden ${
				isRtl ? "rtl" : "ltr"
			}`}
		>
			<SEOHead
				title={t("privacy.title")}
				description={t("privacy.intro").substring(0, 160)}
			/>
			<Container maxWidth="lg" className="px-4 sm:px-8">
				<SectionHeader
					title={t("privacy.title")}
					className="mb-8"
					titleWeight="800"
				/>

				<div
					className={`leading-relaxed text-base mb-8 max-w-4xl mx-auto ${isRtl ? "text-right" : "text-left"}`}
				>
					<p className="mb-8 text-lg font-semibold text-gray-600">
						{t("privacy.lastUpdated")}
					</p>

					<p className="mb-8 text-lg">{t("privacy.intro")}</p>

					{/* 1. Collection */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("privacy.collection.title")}
						</h2>
						<p className="mb-4">{t("privacy.collection.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("privacy.collection.items.contact")}</li>
							<li>{t("privacy.collection.items.order")}</li>
							<li>{t("privacy.collection.items.technical")}</li>
						</ul>
					</section>

					{/* 2. Usage */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("privacy.usage.title")}
						</h2>
						<p className="mb-4">{t("privacy.usage.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("privacy.usage.items.contact")}</li>
							<li>{t("privacy.usage.items.processing")}</li>
							<li>{t("privacy.usage.items.sketches")}</li>
							<li>{t("privacy.usage.items.improvement")}</li>
							<li>{t("privacy.usage.items.confidentiality")}</li>
						</ul>
					</section>

					{/* 3. Sharing */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("privacy.sharing.title")}
						</h2>
						<p className="mb-4">{t("privacy.sharing.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("privacy.sharing.items.providers")}</li>
							<li>{t("privacy.sharing.items.legal")}</li>
						</ul>
					</section>

					{/* 4. Security */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("privacy.security.title")}
						</h2>
						<p>{t("privacy.security.text")}</p>
					</section>

					{/* 5. Cookies */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("privacy.cookies.title")}
						</h2>
						<p>{t("privacy.cookies.text")}</p>
					</section>

					{/* 6. Contact */}
					<section className="mb-12 bg-stone-50 p-8 rounded-xl">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("privacy.contact.title")}
						</h2>
						<p className="mb-4">{t("privacy.contact.text")}</p>
						<ul className="list-none space-y-2 font-semibold">
							<li>{t("privacy.contact.phone")}</li>
							<li>{t("privacy.contact.factory")}</li>
							<li>{t("privacy.contact.office")}</li>
						</ul>
					</section>
				</div>
			</Container>
		</div>
	);
};

export default PrivacyPage;




